import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import LiveCard from "@/components/feature/LiveCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import AnchorCard from "@/pages/home/components/AnchorCard";
import { categories } from "@/mocks/categories";
import { anchors } from "@/mocks/anchors";
import { getLatestLives } from "@/utils/liveData";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "蜜梨直播 - 高清互动直播在线观看平台",
    description:
      "蜜梨直播提供丰富多样的直播内容，包括娱乐、游戏、才艺展示及互动交流，满足用户多元观看需求，尽享优质直播体验。",
    keywords: "蜜梨直播,直播平台,在线直播,互动直播,高清直播,娱乐直播,游戏直播,才艺直播",
  });

  const latestLives = getLatestLives(8);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />

      <main className="w-full flex-1 px-4 py-6 md:px-8">
        <div className="mb-6 flex flex-col gap-1">
          <h1 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            今日精选直播
          </h1>
          <p className="text-sm text-foreground-500">
            发现你感兴趣的直播间，和主播实时互动，享受高清稳定的观看体验。
          </p>
        </div>

        <HeroCarousel />

        <section className="mt-12">
          <div className="mb-4 flex items-end justify-between">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950">分类快捷入口</h2>
              <p className="mt-1 text-sm text-foreground-500">按兴趣一键直达，快速找到想看的直播</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-5 text-center transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${cat.icon} text-2xl`} />
                </span>
                <span className="mt-3 text-sm font-semibold text-foreground-950">{cat.name}</span>
                <span className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                  {cat.intro}
                </span>
              </Link>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <div className="mb-4 flex items-end justify-between">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950">最新开播</h2>
              <p className="mt-1 text-sm text-foreground-500">刚刚开播的直播间，抢先围观</p>
            </div>
            <Link
              to="/search"
              className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              查看全部
              <i className="ri-arrow-right-s-line text-base" />
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {latestLives.map((live) => (
              <LiveCard key={live.id} live={live} />
            ))}
          </div>
        </section>

        <section className="mt-12">
          <div className="mb-4">
            <h2 className="font-heading text-xl font-bold text-foreground-950">热门主播推荐</h2>
            <p className="mt-1 text-sm text-foreground-500">表现优秀的人气主播，值得关注</p>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {anchors.slice(0, 6).map((anchor) => (
              <AnchorCard key={anchor.id} anchor={anchor} />
            ))}
          </div>
        </section>

        <section className="mt-12 overflow-hidden rounded-lg bg-primary-500 px-6 py-10 md:px-10">
          <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
            <div>
              <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                想看的直播，一搜就到
              </h2>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-primary-50">
                输入主播昵称或直播关键词，快速匹配你感兴趣的直播间，娱乐、游戏、才艺内容应有尽有。
              </p>
            </div>
            <Link
              to="/search"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-bold text-primary-600 transition-colors hover:bg-primary-50"
            >
              <i className="ri-search-line text-base" />
              去搜索直播
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}